<template>
  <div>
    <span>{{ $lang("報名完成") }}</span>
  </div>
</template>
<script>
export default {};
</script>
